import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AccountSharedModule } from '@app/account/account-shared.module';
import { LibraryPanesModule } from '@app/library/panes/library-panes.module';
import { TeacherBookingSurfaceBlockComponent } from '@app/teachers/teacher-card/teacher-booking-surface-block/teacher-booking-surface-block.component';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { CoreModule } from '@core/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { ComplaintFormModule } from '@shared/complaint-form/complaint-form.module';

import { IconComponent } from '@shared/icon/icon.component';
import { OnUiButtonModule } from 'onclass-ui';
import { LessonGameComponent } from './lesson-game/lesson-game.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CoreModule,
    ModalModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    SpinnersModule,
    MobileModalModule,
    ComplaintFormModule,
    OnUiButtonModule,
    TeacherBookingSurfaceBlockComponent,
    IconComponent,
    LibraryPanesModule,
    AccountSharedModule,
],
  exports: [LessonGameComponent],
  declarations: [LessonGameComponent],
})
export class GamesModule {}
